import React from 'react';
import './App.css';
import AudioForm from './components/AudioForm/AudioForm';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <h1>Amatourflits</h1>
      </header>
      <AudioForm />
    </div>
  );
}

export default App;
